export enum TokenPurpose {
	INVITATION = "INVITATION",
	FORGOTTEN_PASSWORD = "FORGOTTEN_PASSWORD",
}
